export function amountToAmountMinor(amount: number) {
  return amount * 100
}

export function amountMinorToAmount(minor: number) {
  return isFinite(minor) ? minor / 100 : minor
}
